import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CryptocurrencyFormFields } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/CryptocurrencyFormFields";
import { useEditCryptocurrencyForm } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/useEditCryptocurrencyForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditCryptocurrencyFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditCryptocurrencyForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditCryptocurrencyFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditCryptocurrencyForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<CryptocurrencyFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
